export const PHIL_TRUSTPILOT_IDENTIFIER = "phil-trustpilot-identifier";
export const EMPLOYEE_SPOTLIGHT_TAG = "Employee Spotlight";
export const CENTER_LIFE_SCIENCES_CARD_TAG =
  "CENTER_COMPONENT_CHILDREN_LIFE_SCIENCES_CARD";

export const THANKS_FOR_YOUR_INTEREST = "Thanks for your interest in PhilRx"

export const MEDICATION_ACCESS_SIMPLIFIED = "Medication Access, Simplified"